// extracted by mini-css-extract-plugin
export var deliveryRow = "_kt-a";
export var fixedHeight = "_kt-4";
export var freightLogo = "_kt-9";
export var fullWidth = "_kt-3";
export var priceColumn = "_kt-5";
export var radioSelected = "_kt-7";
export var radioUnselected = "_kt-6";
export var selectedOption = "_kt-2";
export var selectedOptionContainer = "_kt-1";
export var selection = "_kt-0";
export var tallSkeletonText = "_kt-8";